import axios from 'axios'
import { addHttpRequestBreadcrumb, addHttpResponseBreadcrumb, addHttpErrorBreadcrumb } from './sentry'

const instance = axios.create();

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// instance.defaults.withCredentials = true;

// instance.defaults.xsrfCookieName = "csrftoken"
// instance.defaults.xsrfHeaderName = "X-CSRFToken"

instance.interceptors.request.use((config) => {
    if (window.x_session_id) config.headers['X-Session-Id'] = window.x_session_id
    if (window.x_correlation_id) config.headers['X-Correlation-Id'] = window.x_correlation_id

    addHttpRequestBreadcrumb(config, instance.defaults.baseURL || '')

    return config
})

instance.interceptors.response.use(
    (response) => {
        addHttpResponseBreadcrumb(response)
        return response;
    },
    (error) => {
        // Handle any response errors
        addHttpErrorBreadcrumb(error)
        if (error.response) {
            // The request was made and the server responded with a status code that is not in the range of 2xx
            // console.log(error.response.status);
            // if ([401, 419].includes(error.response.status)) {
            //     _vapp && _vapp.$modal ? _vapp.$modal.show('dialog', {
            //         title: 'Session Expired',
            //         text: 'You\'re not logged in. Please refresh the page'
            //     }) : alert('You\'re not logged in. Please refresh the page');

            // }
        } else if (error.request) {
            // The request was made but no response was received
            console.error('AxiosError:EmptyResponse', error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('AxiosError:Setup', error.message);
        }
        return Promise.reject(error);
    }
);

// Object.defineProperty(instance.defaults, "baseURL", {
//     get: () => window.API_HOST || 'x.com'
// });

function setAuthToken(token) {
    if (token) {
      instance.defaults.headers.common["Authorization"] = `Token ${token}`;
    } else {
      delete instance.defaults.headers.common["Authorization"];
    }
}
  
export const storedToken = localStorage.getItem("auth_token");
if (storedToken) {
    setAuthToken(storedToken);
}

export default instance